// Exports
export default {
	"Invite": "Invite_EEJmy",
	"InviteInner": "InviteInner_d4TBU",
	"newGridItem": "newGridItem_XYd6R",
	"ContentWrapper": "ContentWrapper_UtXHM",
	"mainTextWrapper": "mainTextWrapper_O4YyU",
	"MainText": "MainText_IgKQX",
	"ButtonsWrapper": "ButtonsWrapper_5Vs1e",
	"MeetingNumber": "MeetingNumber_lcIuq",
	"MeetingNumberText": "MeetingNumberText_57soH",
	"CopyButton": "CopyButton_1a7x2",
	"CopyButtonIcon": "CopyButtonIcon_AbO9X",
	"CopySmallButton": "CopySmallButton_+MS-G",
	"CopySmallButtonIcon": "CopySmallButtonIcon_wBGPb",
	"CopyNumberButton": "CopyNumberButton_CJXnJ"
};
